import {SET_ERRORS,CLEAR_ERRORS, SET_AREAS, LOADING_DATA_INF, SET_OK, LOADING_UI, SET_AREA, SET_PROGMTOS_INFRA, LOADING_DATA_MTO_INFRA, SET_MTOS_INFRA, SET_MTO_INFRA, SET_CORRECTIVOS_INFRA, SET_CORRECTIVO_INFRA, SET_SOLICITUDESCORR_INFRA, LOADING_DATA_MOB, SET_MOBILIARIOS, SET_MOBILIARIO, SET_PROGMTOS_MOB, LOADING_DATA_MTO_MOB, SET_PROGCALS_ACTIVO, LOADING_DATA_CAL_MOB, POST_SOLICITUD_MTO_ACTIVO, LOADING_SOL_CORR_ACTIVO, SET_SOL_CORR_ACTIVO, POST_EDITPROGMTO_MOB, SET_MTOSPREV_ACTIVO, SET_MTOPREV_ACTIVO, POST_EDITPROGCAL_ACTIVO, SET_CALIBRACIONES_ACTIVO, POST_MTOCORRECTIVO_ACTIVO, SET_MTOSCORRECTIVOS_ACTIVO, SET_MTOCORR_ACTIVO} from '../types';
import axios from 'axios'; 
import { apiV1, apiV2, setAuthorizationHeader } from '../../utils/api';
export const clearErrors = () => (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
  };

export const getMobiliarios =(clienteId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MOB});

    apiV2.get(`/getmobiliario/${clienteId}`)
    .then(res=>{
        dispatch({
            type:SET_MOBILIARIOS,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const postMobiliario=(newMobiliario)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV2
    .post('/crearmobiliario',newMobiliario)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};


 
export const subirMobExcel=(formData,clienteId,handleUser)=>(dispatch)=>{
    dispatch({ type: LOADING_UI });
    apiV2.post(`/subirExcelMobiliario/${handleUser}/${clienteId}`, formData)
      .then((res) => {
        dispatch({
          type: SET_OK,
          payload: res.data
        });
        console.log("Se ejecutó y ahora está en el getCliente");
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data
      });
    });
  }

  export const subirImagenMobiliario=(formData,equipoId,clienteId)=> (dispatch)=>{
    dispatch({type:LOADING_DATA_MOB});
    
    apiV1.post(`/subirimagenmobiliario/${equipoId}`,formData)
    .then(()=>{
      dispatch(getMobiliarios(clienteId));
    })
    .catch(err=>console.log(err)); 
  };

  export const getActivo =(activoId)=>dispatch=>{
      dispatch({type:LOADING_DATA_MOB});
      apiV2.get(`/getactivo/${activoId}`)
      .then(res=>{
          dispatch({
              type:SET_MOBILIARIO,
              payload:res.data
          });
          dispatch(clearErrors());
      }).catch(err=>{
          dispatch({
              type: SET_ERRORS,
              payload:[]
          });
      })
  }

  export const subirDocumentoActivo = (formData, clienteId, mobiliarioId, handleUser) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    apiV2.post(`/subirdocactivo/${handleUser}/${clienteId}/${mobiliarioId}`, formData)
      .then((res) => {
        dispatch({
          type: SET_OK,
          payload: res.data
        });
      })
      .catch((err) => {
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data
        });
      });
  };

  
export const editActivoDetails=(activoDetails,mobiliarioId)=>(dispatch)=>{
    
  dispatch({type:LOADING_UI});
  apiV2.post(`/detailsactivo/${mobiliarioId}`,activoDetails)
  .then((res)=>{
      dispatch({
          type:SET_OK,
          payload:res.data
      });
      
      
  })
  .catch((err)=>{
      dispatch({
      type: SET_ERRORS,
      payload: err.response.data
    })
  }
    ); 
  

  
  console.log('sali de edit');
};

export const progMtoActivo=(newpmto,clienteId,mobiliarioId)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV2
    .post(`/programarmtoactivo/${clienteId}/${mobiliarioId}`,newpmto)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

        dispatch(getprogmtosactivo(mobiliarioId));
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const getprogmtosactivo =(mobiliarioId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MTO_MOB});
    apiV2.get(`/getprogmtoactivo/${mobiliarioId}`)
    .then(res=>{
        dispatch({
            type:SET_PROGMTOS_MOB,
            payload:res.data 
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
};

export const progCalibracionActivo=(newprogcal,clienteId,mobiliarioId)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV2
    .post(`/progcalactivo/${clienteId}/${mobiliarioId}`,newprogcal)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

        //dispatch get programacion mtos
        dispatch(getprogcalsactivo(mobiliarioId)); 
    
       
        //dispatch(getprogmtos(equipoId));
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const getprogcalsactivo =(mobiliarioId)=>dispatch=>{
    dispatch({type:LOADING_DATA_CAL_MOB});
    apiV2.get(`/getprogcalactivo/${mobiliarioId}`)
    .then(res=>{
        dispatch({
            type:SET_PROGCALS_ACTIVO,
            payload:res.data 
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
};

export const postSolicitudMtoCorrectivoActivo = (newSolicitud, mobiliarioId) => dispatch => {
  dispatch({type: LOADING_UI});
  apiV2
      .post(`/solicitarmtocorrectivoactivov2/${mobiliarioId}`, newSolicitud)
      .then((res) => {
          dispatch({
              type: POST_SOLICITUD_MTO_ACTIVO,
              payload: res.data
          });
          dispatch({
              type: SET_OK,
              payload: {
                  mensaje: 'Solicitud enviada exitosamente'
              }
          });
          dispatch(clearErrors());
         
      })
      .catch((err) => {
          dispatch({
              type: SET_ERRORS,
              payload: err.response.data
          });
      });
};

export const getSolicitudesCorrectivosActivo =(mobiliarioId)=>dispatch=>{
    dispatch({type:LOADING_SOL_CORR_ACTIVO});
    apiV2.get(`/getsolicitudescorrectivoactivo/${mobiliarioId}`)
    .then(res=>{
        dispatch({
            type:SET_SOL_CORR_ACTIVO,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
    
}

export const cambiarEstadoActivo=(mobiliarioId,nuevoEstado)=>dispatch=>{
    dispatch({type:LOADING_UI});
    apiV2
    .post(`/cambiarestadoactivo/${mobiliarioId}/${nuevoEstado}`)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

     
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

};

export const deleteActivo=(clienteId,mobiliarioId,history)=>(dispatch)=>{
    
        dispatch({type:LOADING_DATA_MOB});
 
       
        apiV2
        .delete(`/borraractivo/${clienteId}/${mobiliarioId}`)
        .then(() => {
            dispatch(clearErrors());
            history.push(`/dashboard/perfilcliente/${clienteId}/mobiliario`);
        })
        .catch((err) => console.log(err));
        
    }

export const postMtoActivoV2 = (newmtoprev, mobiliarioid, clienteid, progid, handle) => (dispatch) => {
  console.log('Mobiliario Id: ' + mobiliarioid);
  console.log('Cliente Id: ' + clienteid);
  console.log('Prog Id: ' + progid);
  console.log('Handle: ' + handle);
  
  dispatch({ type: LOADING_UI });
  
  // Determinar si necesitamos usar FormData (para firmas digitales, imágenes, o archivos adjuntos)
  const usarFormData =
    newmtoprev.metodoRecepcion === 'firma' ||
    newmtoprev.metodoRecepcion === 'imagen' ||
    newmtoprev.archivoPDF ||
    (Array.isArray(newmtoprev.imagenesAdjuntas) && newmtoprev.imagenesAdjuntas.length > 0);
  
  let requestData;
  let headers = {};
  
  if (usarFormData) {
    requestData = new FormData();

    // Añadir repuestos como campos individuales
    if (Array.isArray(newmtoprev.repuestos)) {
      newmtoprev.repuestos.forEach((valor, index) => {
        requestData.append(`repuesto${index + 1}`, valor);
      });
    }
    
    Object.keys(newmtoprev).forEach(key => {
      const value = newmtoprev[key];

      if (key === 'firmaDigital' && value?.startsWith('data:image')) {
        const blob = dataURItoBlob(value);
        requestData.append('firmaDigital', blob, 'firma.png');
      } else if (key === 'imagenFirma' && value?.startsWith('data:image')) {
        const blob = dataURItoBlob(value);
        requestData.append('imagenFirma', blob, 'imagenFirma.png');
      } else if (key === 'archivoPDF' && value instanceof File) {
        requestData.append('archivoPDF', value, value.name);
      } else if (key === 'imagenesAdjuntas' && Array.isArray(value)) {
        value.forEach((imgFile, index) => {
          if (imgFile instanceof File) {
            requestData.append(`imagenAdjunta${index + 1}`, imgFile, imgFile.name);
          }
        });
      } else if (
        key !== 'repuestos' &&
        (typeof value !== 'object' || value === null)
      ) {
        requestData.append(key, value);
      }
    });
  } else {
    // Para métodos sin archivos, usamos JSON normal
    requestData = newmtoprev;
    headers = {
      'Content-Type': 'application/json'
    };
  }
  
  // Configuraciones para la petición axios
  const config = {
    headers
  };
  
  // Using the new API endpoint for Firebase v2
  apiV2
    .post(`/postmtoprevenactivo/${clienteid}/${mobiliarioid}/${handle}/${progid}`, requestData, config)
    .then((res) => {
      dispatch({
        type: SET_OK,
        payload: res.data
      });
      dispatch(clearErrors());

      // Update the maintenance program status
      dispatch(editProgMtoActivo({ nuevoestado: 'Realizado' }, progid, clienteid));
    })
    .catch((err) => {
      console.error('Error en postMtoActivoV2:', err);
      dispatch({
        type: SET_ERRORS,
        payload: err.response?.data || { error: 'Error al procesar la solicitud' }
      });
    });
};

/**
 * Helper to convert base64 to Blob for FormData
 */
function dataURItoBlob(dataURI) {
    // Convert base64/URLEncoded data component to raw binary data
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1]);
    } else {
      byteString = unescape(dataURI.split(',')[1]);
    }
  
    // Separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  
    // Write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
  
    return new Blob([ia], { type: mimeString });
  }
  

  export const editProgMtoActivo=(nuevoestado,progid)=>(dispatch)=>{
      apiV2
      .post(`/editprogmtoactivo/${progid}`,nuevoestado)
      .then((res)=>{
          dispatch({
              type:POST_EDITPROGMTO_MOB,
              payload:res.data
          });
          dispatch(clearErrors());
          
      })
      .catch((err)=>{
          dispatch({
              type: SET_ERRORS,
              payload: err.response.data
            });
      });
  }

  export const deleteProgMtoActivo =(clienteid,progid,mobiliarioid,handleuser)=>(dispatch)=>{
      dispatch({type:LOADING_UI});
      apiV2
      .delete(`/deleteprogmtoactivo/${clienteid}/${progid}/${handleuser}`)
      .then((res) => {
          dispatch({
              type:SET_OK,
              payload:res.data
          });
          dispatch(clearErrors());
  
          //dispatch get programacion mtos
                 
        
      })
      .catch((err) => console.log(err));
  }

  export const getmtosprevactivo =(mobiliarioId)=>dispatch=>{
      dispatch({type:LOADING_DATA_MTO_MOB});
      apiV2.get(`/getmtosprevactivo/${mobiliarioId}`)
      .then(res=>{
          dispatch({
              type:SET_MTOSPREV_ACTIVO,
              payload:res.data 
          });
          dispatch(clearErrors());
      }).catch(err=>{
          dispatch({
              type: SET_ERRORS,
              payload:[]
          });
      })
      
  };

  export const deleteMtoPreventivoActivo =(mtoid,mobiliarioid,clienteid,handleuser)=>(dispatch)=>{
      dispatch({type:LOADING_UI});
     
      apiV2
      .delete(`/deletemtoprevactivo/${clienteid}/${mtoid}/${handleuser}`)
      .then((res) => {
          dispatch({
              type:SET_OK,
              payload:res.data
          });
        
          dispatch(getmtosprevactivo(mobiliarioid));
      })
      .catch((err) => console.log(err));
  }

  export const getMtoPrevActivo =(mtoId)=>dispatch=>{
      dispatch({type:LOADING_DATA_MOB});
      apiV2.get(`/getmtopreventivoactivo/${mtoId}`)
      .then(res=>{
          dispatch({
              type:SET_MTOPREV_ACTIVO,
              payload:res.data
          });
          dispatch(clearErrors());
      }).catch(err=>{
          dispatch({
              type: SET_ERRORS,
              payload:[]
          });
      })
  }

export const postCalibracionActivo=(newcal,clienteid,mobiliarioid,handleuser)=>(dispatch)=>{
    dispatch({type:LOADING_UI});
    apiV2
    .post(`/postcalibracionactivo/${clienteid}/${mobiliarioid}/${handleuser}`,newcal)
    .then((res)=>{
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());

     
        
        
    })
    .catch((err)=>{
        dispatch({
            type: SET_ERRORS,
            payload: err.response.data
          });
    });

}

export const deleteProgCalActivo =(progid,mobiliarioid,clienteid,handleuser)=>(dispatch)=>{
    dispatch({type:LOADING_UI});
    apiV2
    .delete(`/deleteprogcalactivo/${clienteid}/${progid}/${handleuser}`)
    .then((res) => {
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());
        dispatch(getprogcalsactivo(mobiliarioid));
        
      
    })
    .catch((err) => console.log(err));
}


export const subirArchivoCalActivo = (formData, calibracionId) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  
  apiV2
    .post(`/subirarchivocalactivo/${calibracionId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((res) => {
      // Verificar si la respuesta tiene el mensaje 'aprobado'
      dispatch({
        type:SET_OK,
        payload:res.data
       });
    dispatch(clearErrors());
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response && err.response.data ? err.response.data : { error: 'Error al conectar con el servidor' }
      });
    });
};

export const getCalibracionesActivo =(mobiliarioId)=>dispatch=>{
    dispatch({type:LOADING_DATA_CAL_MOB});
    apiV2.get(`/getcalibracionesactivo/${mobiliarioId}`)
    .then(res=>{
        dispatch({
            type:SET_CALIBRACIONES_ACTIVO,
            payload:res.data 
        });
        console.log("Obtuve Calibraciones")
        dispatch(clearErrors());
        
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
        console.log("Algo salio Mal en Obtener Calibraciones")
    })
    
};

export const deleteCalActivo =(calibracionid)=>(dispatch)=>{
    dispatch({type:LOADING_UI});
    apiV2
    .delete(`/deletecalactivo/${calibracionid}`)
    .then((res) => {
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());
        
        
      
    })
    .catch((err) => console.log(err));
}


export const postMtoCorrectivoActivo = (newmtocorr, mobiliarioid, clienteid, solicitudid) => (dispatch) => {
  dispatch({type: LOADING_UI});
  
  // Comprobar si tenemos una firma digital o imagen que enviar
  if (newmtocorr.metodoRecepcion === 'firma' || newmtocorr.metodoRecepcion === 'imagen') {
      // Crear un objeto FormData para enviar archivos
      const formData = new FormData();
      
      // Agregar todos los campos del objeto newmtocorr al FormData
      Object.keys(newmtocorr).forEach(key => {
          // Ignorar el campo de imagen por ahora
          if (key !== 'imagenFirma') {
              // Para valores booleanos, convertirlos a cadenas
              if (typeof newmtocorr[key] === 'boolean') {
                  formData.append(key, newmtocorr[key].toString());
              } else {
                  formData.append(key, newmtocorr[key]);
              }
          }
      });
      
      // Convertir la cadena base64 a Blob y agregarla como archivo
      if (newmtocorr.imagenFirma) {
          // Extraer la parte de datos de la URL de datos
          const base64Data = newmtocorr.imagenFirma.split(',')[1];
          const blob = b64toBlob(base64Data, 'image/png');
          formData.append('file', blob, 'firma.png');
      }
      
      // Luego, enviar el FormData
      apiV2.post(`/postmtocorrectivoactivo/${clienteid}/${mobiliarioid}/${solicitudid}`, formData, {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
      })
      .then((res) => {
          
          dispatch({
              type: SET_OK,
              payload: {
                  mensaje: 'Mantenimiento enviado exitosamente'
              }
          });
          dispatch(clearErrors());
      })
      .catch((err) => {
        console.error('🛑 Error en postMtoCorrectivoActivo:', err);
        console.log('🧾 Error completo:', JSON.stringify(err, null, 2)); // o usa err.toJSON() si es Axios
        console.log('🔍 err.response:', err.response);
        console.log('📄 err.response?.data:', err.response?.data);
        dispatch({
          type: SET_ERRORS,
          payload: err.response?.data || { general: 'Ocurrió un error inesperado. Revisa tu conexión o intenta más tarde.' }
        });
      });
  } else {
      // Para métodos sin imágenes, hacer una solicitud JSON regular
      apiV2.post(`/postmtocorrectivoactivo/${clienteid}/${mobiliarioid}/${solicitudid}`, newmtocorr)
      .then((res) => {
         
          dispatch({
              type: SET_OK,
              payload: {
                  mensaje: 'Mantenimiento Enviado exitosamente'
              }
          });
          dispatch(clearErrors());
      })
      .catch((err) => {
        console.error('🛑 Error en postMtoCorrectivoActivo:', err);
        console.log('🧾 Error completo:', JSON.stringify(err, null, 2)); // o usa err.toJSON() si es Axios
        console.log('🔍 err.response:', err.response);
        console.log('📄 err.response?.data:', err.response?.data);
        dispatch({
          type: SET_ERRORS,
          payload: err.response?.data || { general: 'Ocurrió un error inesperado. Revisa tu conexión o intenta más tarde.' }
        });
      });
  }
};

// Función auxiliar para convertir base64 a Blob
function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      
      for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }
      
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {type: contentType});
  return blob;
}


export const subirEvidenciaMtoCorrectivoActivo = (formData, mtoid) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    apiV2.post(`/subirevidenciamtocorractivo/${mtoid}`, formData)
      .then((res) => {
        dispatch({
          type: SET_OK,
          payload: res.data
        })
        dispatch(clearErrors());
     
      })
      .catch(err => console.log(err));
  };

  export const getMtosCorrectivosActivo =(mobiliarioId)=>dispatch=>{
      dispatch({type:LOADING_DATA_MTO_MOB});
      apiV2.get(`/getmtoscorrectivosactivo/${mobiliarioId}`)
      .then(res=>{
          dispatch({
              type:SET_MTOSCORRECTIVOS_ACTIVO,
              payload:res.data 
          });
          
          dispatch(clearErrors());
          
      }).catch(err=>{
          dispatch({
              type: SET_ERRORS,
              payload:[]
          });
      })
      
  };

  export const deleteCorrectivoActivo =(correctivoId)=>(dispatch)=>{
    dispatch({type:LOADING_UI});
    apiV2
    .delete(`/deletecorractivo/${correctivoId}`)
    .then((res) => {
        dispatch({
            type:SET_OK,
            payload:res.data
        });
        dispatch(clearErrors());
        
        
      
    })
    .catch((err) => console.log(err));
}

export const getMtoCorrActivo =(mtoId)=>dispatch=>{
    dispatch({type:LOADING_DATA_MOB});
    apiV2.get(`/getmtocorrectivoactivo/${mtoId}`)
    .then(res=>{
        dispatch({
            type:SET_MTOCORR_ACTIVO,
            payload:res.data
        });
        dispatch(clearErrors());
    }).catch(err=>{
        dispatch({
            type: SET_ERRORS,
            payload:[]
        });
    })
}

